import * as React from "react";
import fadeIn from "../../Utilities/Scripts/fadeIn";

class IntroCard extends React.Component {
  componentDidMount() {
    fadeIn(document.getElementById("intro-card-name"));
    fadeIn(document.getElementById("intro-card-bio"));
  }

  render() {
    return (
      <div className="intro-card">
        <div className="intro-card-wrapper">
          <div className="intro-card-name" id="intro-card-name">
            sunil sivadas
          </div>
          <div className="intro-card-bio" id="intro-card-bio">
            coder. gamer. geek.
          </div>
        </div>
      </div>
    );
  }
}

export default IntroCard;
